/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * AdminPolicy.tsx
 */

import Policy from "../tools/provider/Policy";

export default class AdminPolicy implements Policy {
    /**
     * canSeeUsers
     * @returns {boolean}
     */
    public canSeeUsers(): boolean {
        return true;
    }
}